import React from 'react';
import { Header, INavLink } from '@clinicaltoolkits/universal-react-components';
import demoLogoPng from "../../assets/demo_logo2.png"; // <-- gets the hashed URL string

const links: INavLink[] = [
  {
    link: "about",
    label: "About",
    sublinks: [
      {
        link: "about/team",
        label: "Team",
      },
      {
        link: "mission",
        label: "Mission",
      },
    ]
  },
  { link: "services", label: "Services" },
  { link: "fees", label: "Fees" },
  { link: "contact", label: "Contact" },
];

export const SiteHeader = () => {
  return (
    <Header
      logoVariants={{
        small: <DemoLogo />,
        medium: <DemoLogo />,
        large: <DemoLogo />,
      }}
      logoSize={100}
      redirectAddress="/"
      links={links}
      // Optional:
      //loginSignupButtons={<div/>}
      drawerTitle="Menu"
    />
  );
};

export const DemoLogo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (
  props,
) => (
  <img
    src={demoLogoPng}
    alt="Demo logo"
    style={{ width: '100%', height: '100%', display: 'block' }}
    {...props}
  />
);